import convertFields from "./convertFields";

const formatFormData = ({ data, type, sport }) => {
  const formattedData = {};

  Object.keys(data)?.forEach((name) => {
    if (data[name] !== undefined) {
      formattedData[name] = data[name];
    }
  });

  const { name, defaultProfile, ...profile } = formattedData;

  // convert data
  const convertedData = convertFields({ data: profile, type, sport });

  return { name, defaultProfile, profile: convertedData };
};

export default formatFormData;
